import React from 'react';
interface ArticleCardProps {
  imageUrl?: string;
  title?: string;
  description?: string;
  category?: string;
  hasShadow?: boolean;
  index?: number;
}
export function ArticleCard({
  imageUrl,
  title = 'The US agencies storming up the World Creative Rankings',
  description = "Special Group, a global independent creative network, was the year's biggest climber in North America.",
  category = 'NEWS',
  hasShadow = false
}: ArticleCardProps) {
  const hasImage = imageUrl && imageUrl !== '#D9D9D9';
  return <div className="flex flex-col group cursor-pointer w-full" data-id="element-5">
      <div className="w-full overflow-hidden" style={{
      aspectRatio: '430/225',
      borderRadius: '25px',
      backgroundColor: '#D9D9D9',
      boxShadow: hasShadow ? 'inset 0px 4px 4px rgba(0,0,0,0.25)' : undefined
    }} data-id="element-6">
        {hasImage && <img src={imageUrl} alt={title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-7" />}
      </div>
      {/* Title card overlaps image via negative margin, stays in flow */}
      <div className="mx-[8%] relative z-10" style={{
      marginTop: '-40px'
    }} data-id="element-8">
        <div className="bg-white" style={{
        borderRadius: '20px',
        padding: '16px 20px 10px 20px'
      }} data-id="element-9">
          <h3 className="font-bold" style={{
          color: '#6B6B6B',
          fontSize: 'clamp(16px, 1.5vw, 20px)',
          fontFamily: 'Poppins',
          fontWeight: 700,
          lineHeight: 'normal'
        }} data-id="element-10">
            {title}
          </h3>
        </div>
      </div>
      <div className="px-4 lg:px-5" style={{
      marginTop: '8px'
    }} data-id="element-11">
        <p className="line-clamp-3" style={{
        color: '#6B6B6B',
        fontSize: '15px',
        fontFamily: 'Poppins',
        fontWeight: 400,
        lineHeight: 'normal'
      }} data-id="element-12">
          {description}
        </p>
        <div className="mt-4" data-id="element-13">
          <span className="inline-block font-bold uppercase cursor-pointer transition-colors duration-200 hover:bg-gray-50" style={{
          border: '1px solid #6B6B6B',
          borderRadius: '25px',
          padding: '4px 16px',
          color: '#6B6B6B',
          fontSize: '15px',
          fontFamily: 'Poppins',
          fontWeight: 700,
          lineHeight: 'normal',
          letterSpacing: '0.1em'
        }} data-id="element-14">
            {category}
          </span>
        </div>
      </div>
    </div>;
}